import * as React from 'react';
import { cn } from '@/lib/cn';

export const Input = React.forwardRef<HTMLInputElement, React.InputHTMLAttributes<HTMLInputElement>>(
  ({ className, type = 'text', ...props }, ref) => (
    <input
      ref={ref}
      type={type}
      className={cn(
        'block w-full h-10 rounded-[var(--radius-input)] border-0 bg-bg px-3 py-2 text-sm text-text outline-1 -outline-offset-1 outline-border placeholder:text-text-subtle',
        'focus:outline-2 focus:-outline-offset-2 focus:outline-accent',
        'disabled:cursor-not-allowed disabled:opacity-50',
        className
      )}
      {...props}
    />
  )
);
Input.displayName = 'Input';
